import { Injectable } from '@angular/core';
import { ConfigProvider } from '../config/config';

@Injectable({ providedIn: 'root' })
export class NomenclaturaService {
  constructor(public configProvider: ConfigProvider) {}

  transform(value: string): Promise<string> {
    return this.configProvider.getNomenclatura(value).then((nomenclatura) => {
      return nomenclatura;
    });
  }
}
